module.exports = __webpack_public_path__ + "static/media/13.20218a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/13.jpg
// module id = 174
// module chunks = 0